import { isNull, isNumber } from 'lodash'

import { COMMENT_ENTITY_KEYS } from '@/utils/entity-keys'

export const validateRepliesToShowCount = (count = 1) => {
  const isValid = count === Infinity || (isNumber(count) && Number.isInteger(count) && count > 0)

  if (!isValid) {
    throw new Error('Invalid repliesToShowCount. It must be a positive integer or Infinity.')
  }

  return count
}

const findCommentById = ({ comments = [], commentId }) => {
  return comments.find(comment => comment[COMMENT_ENTITY_KEYS.ID] === commentId)
}

const replaceReactions = ({ comment, reactions }) => {
  comment[COMMENT_ENTITY_KEYS.REACTIONS] = reactions
}

export const updateCommentReactions = ({ comments = [], commentId, parentId, reactions }) => {
  if (!commentId) return

  if (isNull(parentId)) {
    const comment = findCommentById({ comments, commentId })
    if (!comment) return
    replaceReactions({ comment, reactions })
  } else {
    const parentComment = findCommentById({ comments, commentId: parentId })
    if (!parentComment) return

    updateCommentReactions({
      comments: parentComment[COMMENT_ENTITY_KEYS.CHILD_COMMENTS],
      commentId,
      parentId: null,
      reactions
    })
  }
}

export const getReactionCount = reaction => {
  const { users = [] } = reaction || {}

  const maxCount = 99
  const usersLength = users.length
  return usersLength > maxCount ? `${maxCount}+` : usersLength
}
